import { StudyStartUpModel } from '@app/ti-components/study-start-up/models/study-start-up.interfaces';
import { SingleCountry } from '@app/origami-api/services/country.service';
import { FieldNames } from '@app/origami-api/constants/field-names';
import { SubmissionProfileStatus } from '@app/origami-api/services/submission-profile.service';
import { FilterWithMatchingTopicTypeIdOptions, GridTopicFieldRenderer } from '@app/shared/grid/grid-options';

export namespace CountriesModel {
  import DropdownItem = StudyStartUpModel.DropdownItem;
  import Country = FieldNames.Country;

  export interface CountriesColumnOptions {
    topicTypes?: string;
    columnsFromTopicTypeTopicFields?: string;
    topicTypeRenderers: GridTopicFieldRenderer<any, any>[];
    forms?: FilterWithMatchingTopicTypeIdOptions;
  }

  export enum CountriesCodingVariant {
    COUNTRY = 1,
    AGENCY_SUBMISSION,
    DOCUMENT,
    AMENDMENTS,
    SITES,
    SECURITY,
    IRB_EC,
    IRB_EC_DETAILS,
    COMMUNICATION_LOG,
    Countries,
  }

  export enum CountryStatus {
    Planned = 1,
    Submitted = 2,
    Active = 3,
    Closed = 4,
    OnHold = 5,
    Canceled = 6,
    Rejected = 7,
  }

  export enum CountriesLayoutViewType {
    MAIN_COUNTRY_VIEW = 1,
    IRB_EC_COUNTRY_VIEW,
    AMENDMENT_COUNTRY_VIEW,
    ETMF_COUNTRY_VIEW,
    KPI_COUNTRY_VIEW,
    PACKAGES_COUNTRY_VIEW,
  }

  export interface CountriesMetadataForm {
    country: string;
    comment: string;
    status: DropdownItem;
    currentStatusDate?: Date;
    expectedActivationDate: Date;
    activationDate: Date;
  }

  export interface SSUCountryCodingOptions {
    entities: SingleCountry;
  }

  export enum DocumentUploadStatus {
    PENDING,
    INPROGRESS,
    SUCCESS,
    FAILURE,
    CANCELLED,
    FINALIZING,
    NOT_IMPORTED,
  }

  export enum ToolbarComponentType {
    COUNTRY_DETAILS = 1,
    AGENCY_SUBMISSION,
    DOCUMENT,
    AMENDMENTS,
    SITES,
    SECURITY,
    IRB_EC,
    COMMUNICATION_LOG,
    DASHBOARD,
    COUNTRY_WORKFLOW,
  }

  export enum EtmfToolbarComponentType {
    COUNTRY_DETAILS = 1,
    DOCUMENT,
    SITES,
    SECURITY,
  }

  export enum AsideBarType {
    COUNTRY = 1,
    IRB_EC,
    SITES,
    AMENDMENTS,
    CONTACTS,
  }

  export interface CountriesLayoutActionsParams {
    icon?: string;
    text?: string;
    showWhen?: StateToolbarBtn;
    defaultHidden?: boolean;
    activeWhen?: StateToolbarBtn;
    defaultDisable?: boolean;
  }

  export enum StateToolbarBtn {
    NO_SELECT_ITEMS = 1,
    SELECT_ONE_ITEM,
    SELECT_MANY_ITEM,
    ALWAYS_SHOW_OR_ENABLE,
    ALWAYS_HIDE_OR_DISABLE,
    MANAGER_OR_HIGHER,
    EDITOR_OR_HIGHER,
    READER_OR_HIGHER,
  }

  export interface IData {
    text: string;
    value: number | string;
  }

  export interface IStatusData extends IData {
    statusId: SubmissionProfileStatus;
  }

  export const CountriesGeneralInfoFields = [
    Country.Country,
    Country.Status,
    Country.StatusDate,
    Country.Comments,
    Country.TrackAgencySubmissionProgress,
  ];

  export interface BackLink {
    text: string;
    link: string;
  }
}
